import { notification } from 'antd';

export const sendNotify = (type, content) => {
    notification.open({
      type: type,
      message: content,
    });
};